import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { queryReducer } from './reducers/query';
import categoriesReducer from './reducers/categories';
import stringsReducer from './reducers/strings';
import uiReducer from './reducers/ui';
import { validateQuery } from './actors/validateQuery';
import { reduxBatch } from '@manaflair/redux-batch';
import requiredUserActionsReducer from './reducers/requiredUserActions';
import previewReducer from './reducers/preview';

const rootReducer = combineReducers({
    query: queryReducer,
    categories: categoriesReducer,
    requiredUserActions: requiredUserActionsReducer,
    preview: previewReducer,
    strings: stringsReducer,
    ui: uiReducer,
});

export function createNewStore() {
    const middlewares = [];

    if (__ENABLE_LOGS__ || localStorage.getItem('debug')) {
        const logger = createLogger({
            // predicate: (getState, action) => loggerConfig.enabled,
            collapsed: (getState, action, logEntry) => !logEntry.error,
        });
        middlewares.push(logger);
    }

    const store = createStore(rootReducer, compose(reduxBatch, applyMiddleware(...middlewares), reduxBatch));

    store.subscribe(() => {
        const { query, categories } = store.getState(),
            nextAction = validateQuery(categories, query);

        if (nextAction) {
            store.dispatch(nextAction);
        }
    });

    return store;
}
